import React from 'react'
import iconSVG from '../../static/img/logo.svg';
import { Link } from 'react-router-dom'
import Footer from '../../components/footer';

const BasicPage = (props) => (
  <div
    style={{
      display: "flex",
      margin: "3rem auto",
      maxWidth: "660px",
      flexDirection: "column",
      paddingLeft: "2rem",
      paddingRight: "2rem"
    }}
  >
    <header>
      <Link to="/"
        style={{
          width: "100%",
          borderBottom: "1px solid #eee",
          display: "block",
          marginBottom: "1rem"
        }}
      >
        <img src={iconSVG}
          style={{
            width: "120px",
            marginBottom: "2rem"
          }}
        />
      </Link>
    </header>
    {props.children}
    <Footer />
  </div>
)
export default BasicPage;



// WEBPACK FOOTER //
// ./src/components/basicpage/index.js